@if(appStateService.sidepanelInfoExpanded()) {
    <app-projekt-info class="flex flex-fill"></app-projekt-info>
}
@if(appStateService.sidepanelHistoryExpanded()) {
    <app-budget-verlauf class="flex flex-fill"></app-budget-verlauf>   
}
